import { jsx as _jsx } from "react/jsx-runtime";
const RichTextTableCaption = ({ children }) => (_jsx("caption", { className: "sr-only", children: children }));
RichTextTableCaption.displayName = 'RichTextTableCaption';
export default RichTextTableCaption;
//# sourceMappingURL=TableCaption.js.map